import { ConnectButton } from '@rainbow-me/rainbowkit'
import React from 'react'
import Web3 from 'web3'
import {
	useAccount,
	useChainId,
  	usePrepareTransactionRequest,
  	useSendTransaction,
  	useWaitForTransactionReceipt,
} from 'wagmi'
import { parseEther } from 'viem'
import { config } from './config'

import x from './imgs/icon--twitter.png'
import closeImg from './imgs/close.png'

import dd from './imgs/h-icon.png'
import pend from './imgs/pending.gif'

import uwu from './imgs/uwu.png'
import xi from './imgs/x-icon.png'
import ce from './imgs/cute-edwin.png'
import bg from './imgs/bg.gif'
import mc from './imgs/mc.png'
import usdc from './imgs/usdc.png'
import husd from './imgs/husd.png'
import planet from './imgs/planet.png'
import {pools, poolImage} from './pools.js'
import sts from './imgs/sts.webp'
import ex from './imgs/ex.png'
import xex from './imgs/xex.png'
const EX_LIMIT = 200000


const getTransactionReceipt = (hash, callback= ()=>{}) => {
    console.log(hash)
    window.ethereum.request({
      method: "eth_getTransactionReceipt",
      params: [hash]
    }).then((res)=>{
      if (res == null) {
        getTransactionReceipt(hash, callback)
      }
      callback(res)
    }).catch((err)=>{
      console.log(err)
    })
  }

 const web3 = new Web3(new Web3.providers.HttpProvider('https://rpc.blaze.soniclabs.com'));
//const web3 = new Web3(new Web3.providers.HttpProvider('https://rpc.soniclabs.com'));
export function Web3App (props) {
	const [cost, setCost] = React.useState(100)  
	const [pending, setIsPending] = React.useState(false)
	const [pendingText, setPendingText] = React.useState("Transaction is in process") 
	const { address, isConnected } = useAccount()
	const chainId  = useChainId()

	const [networkConfig, setNetworkConfig] = React.useState(config["testnet"])
	const [hubbleBalance, setHubbleBalance] = React.useState(0)
	const [xhubbleBalance, setXHubbleBalance] = React.useState(0)
	const [vestInfo, setVestInfo] = React.useState({amt:0,start:0,end:0,id:0})
	const [vestCount, setVestCount]= React.useState(0)
	const [activeVest, setActiveVest] = React.useState(0)

	const [totalSubmissions, setTotalSubmissions] = React.useState(0)
	const [wlCount, setWlCount] = React.useState(0)

	const [activeStep, setActiveStep] = React.useState(0)

	const [theList, setTheList] = React.useState([])
	const [theNames, setTheNames] = React.useState([])
	const [theSymbols, setTheSymbols] = React.useState([])

	const [mcBalance, setMcBalance] = React.useState(0)

	const [navMobileToggle, setNavMobileToggle] = React.useState(false)

	const [hubble_price, set_hubble_price] = React.useState(0)

	const [stsBalance, setStsBalance] = React.useState(0)
	const [exBalance, setExBalance] = React.useState(0)
	const [xexBalance, setXexBalance] = React.useState(0)

	const [vestXEXCount, setVestXEXCount] = React.useState(0)
	const [activeXEXVest, setActiveXEXVest] = React.useState(0)
	const [vestXEXInfo, setVestXEXInfo] = React.useState({amt:0,start:0,end:0,id:0})
	const ogMintRef = React.createRef(null)

	const HUBBLE = new web3.eth.Contract(
		networkConfig["hubble"]["abi"], 
		networkConfig["hubble"]["address"])
	const xHUBBLE = new web3.eth.Contract(
		networkConfig["xhubble"]["abi"], 
		networkConfig["xhubble"]["address"])
	const wl = new web3.eth.Contract(
		networkConfig["wl"]["abi"], 
		networkConfig["wl"]["address"])
	const MC = new web3.eth.Contract(
		networkConfig["mc"]["abi"], 
		networkConfig["mc"]["address"])
	const VotingModule = new web3.eth.Contract(
		networkConfig["vm"]["abi"], 
		networkConfig["vm"]["address"])
	const RewardModule = new web3.eth.Contract(
		networkConfig["rm"]["abi"], 
		networkConfig["rm"]["address"])


	const MC2 = new web3.eth.Contract(
		networkConfig["mc2"]["abi"], 
		networkConfig["mc2"]["address"])

	const STS = new web3.eth.Contract(
		networkConfig["sts"]["abi"], 
		networkConfig["sts"]["address"])

	const EXMINT = new web3.eth.Contract(
		networkConfig["exmint"]["abi"], 
		networkConfig["exmint"]["address"])

	const EX = new web3.eth.Contract(
		networkConfig["ex"]["abi"], 
		networkConfig["ex"]["address"])
	const XEX = new web3.eth.Contract(
		networkConfig["xex"]["abi"], 
		networkConfig["xex"]["address"])
	const EX121 = new web3.eth.Contract(
		networkConfig["ex121"]["abi"], 
		networkConfig["ex121"]["address"])

	const hubbleRef = React.createRef(null)
	const unlockRef = React.createRef(null)
	const vestRef = React.createRef(null)
	const wlRef = React.createRef(null)

	const stakeRef = React.createRef(null)
	const unstakeRef = React.createRef(null)
	const [mc2Bal, setMc2bal] = React.useState(0)
    const mc2StakeRef = React.createRef(null)
    const mc2UnstakeRef = React.createRef(null)
    	const [demBal, setDembal] = React.useState(0)
    const demStakeRef = React.createRef(null)
    const demUnstakeRef = React.createRef(null)
    const hubblerMintRef = React.createRef(null)
    const exRef = React.createRef(null)
    const xexRef = React.createRef(null)
    const vestXEXRef = React.createRef(null)
     const exMintRef = React.createRef(null)
const [hubblerRemainingDiscounts, setHubblerRemainingDiscounts] = React.useState(0)
const [ogRemainingDiscounts, setOgRemainingDiscounts] = React.useState(0)
const [remainingMints, setRemainingMints] = React.useState(0)
const [hubblerMints, setTotalHubblerMints] = React.useState(0)
const [ogMints, setTotalOgMints] = React.useState(0)
const [exMints, setExMints] = React.useState(0)
const [isMinting, setIsMinting] = React.useState(false)
const [isMintingOG, setIsMintingOG] = React.useState(false)
const [isMintingHubbler, setIsMintingHubbler] = React.useState(false)
const [isAnOg, setIsAnOg] = React.useState(false)
	  React.useEffect(
	  	() => {
	  		if (isConnected) {
	  			getBal(HUBBLE,(a)=>{
	  				setHubbleBalance(a)
	  				getBal(xHUBBLE,(b)=>{
	  					setXHubbleBalance(b)
	  					setActiveStep(1)
	  					getBal(
	  						STS,
	  						(_sts)=>{
	  							setStsBalance(_sts)
	  							getBal(
	  								EX,
	  								(_ex)=>{
	  									setExBalance(_ex)
	  									getBal(
	  										XEX,
	  										(_xex)=>{
	  											setXexBalance(_xex)
	  											gexData()
	  										})
	  								}
	  								)
	  						}
	  						)
	  				})

	  			})
	  		}
	  	},
	  	[isConnected]
	  	)
	React.useEffect(()=>{
		if (activeStep == 2) {
			getVestCount()
			getVestXEXCount()
		}
		else if (activeStep == 5) {
		
			
			getDEMInfo(getDemUserInfo(getPendingRewardsDEM()))
		
		}
		else if (activeStep == 3) {
			getMcBalance(getMC2Info(getUserInfo(getPendingRewards())))
			
		}
	},[activeStep])

	React.useEffect(()=>{
		if(isConnected) {
			getVestInfo(activeVest)
		}
		
	},[vestCount, activeVest])

	React.useEffect(()=>{
		if(isConnected) {
			getVestXEXInfo(activeXEXVest)
		}
		
	},[vestXEXCount, activeXEXVest])
	

	
	const estimateGas = (contract, data, callback = ()=>{}) => {
		if (typeof window.ethereum !== 'object') {
			alert("Please open this page in the Metamask browser")
		} 
		else {
			window.ethereum.request(
		        {
		          method: "eth_estimateGas",
		          params: [
		            {
		              from: address,
		              to: contract,     
		              value: web3.utils.toHex(0),
		              data: data,
		            },
		          ],
		        }
		      ).then((gasAmount)=>{
		      	console.log(gasAmount)
		        callback(gasAmount)
		      }).catch((err)=>{
		        alert(err.data.message)
		      })
		}
	}
	const sendRequest = (contract, data, callback = ()=>{}) => {
		estimateGas(
			contract,
			data,
			() => {
				setIsPending(true)
				if (typeof window.ethereum !== 'object') { 
				
				} else {
					window.ethereum.request({
						method: "eth_sendTransaction",
						params: [
						  {
						    from: address,
						    to: contract,
						    value: 0,
						    data: data,
						  },
						],}).then((hash)=>{
						  getTransactionReceipt(hash,(receipt)=>{
						    if (receipt != null) {
						      setIsPending(false)
						      callback()
						    }
						  })
						}).catch((err)=>{
						  setIsPending(false)
						})	
					}		
			}
			)
	}


const getBal = (contract, callback = ()=>{}) => {
	contract.methods.balanceOf(address)
		.call({from: address})
		.then((bal)=>{
			callback(bal)
		})
}
const checkAllowance = (contract, spender, amount, callback = ()=>{}) =>{
	contract.methods.allowance(address, spender)
		.call({from: address})
		.then((allowance)=>{
			callback(allowance)
		})
}

const approve = (contract, spender, amount, callback = ()=>{}) => {

	let data = contract.methods.approve(spender,amount).encodeABI()
	sendRequest(
		contract.options.address,
		data,
		callback)
}

const mintHubble = () => {
	let data = HUBBLE.methods.mint().encodeABI()
	setPendingText("Minting 42 $HUBBLE on testnet")

	sendRequest(
		HUBBLE.options.address,
		data,
		()=>{
			getBal(HUBBLE,(bal)=>{
				setHubbleBalance(bal)
			})
		})
		
		
	
}

const lock = () => {
	if (Number(hubbleRef.current.value) == 0) {
		alert("Enter a nonzero value")
	}
	else {
		let amt = web3.utils.toWei(hubbleRef.current.value,"ether")
		let data = xHUBBLE.methods.lock(amt).encodeABI()

		checkAllowance(
			HUBBLE,
			xHUBBLE.options.address,
			amt,
			(allowance) => {
				let alw = web3.utils.fromWei(allowance,"ether")
				if (alw >= Number(hubbleRef.current.value)) {
					setPendingText("Locking $HUBBLE")
					sendRequest(
						xHUBBLE.options.address,
						data,
						()=>{
							getBal(HUBBLE,(bal)=>{
								setHubbleBalance(bal)
							})
							getBal(xHUBBLE,(bal)=>{
								setXHubbleBalance(bal)
								gexData()
							})
						})
				} 
				else {
					setPendingText("Approving your HUBBLE for use by the xHUBBLE contract.")
					approve(
						HUBBLE,
						xHUBBLE.options.address,
						amt,
						()=>{
							setPendingText("Locking $HUBBLE")
							sendRequest(
							xHUBBLE.options.address,
							data,
							()=>{
								getBal(HUBBLE,(bal)=>{
									setHubbleBalance(bal)
								})
								getBal(xHUBBLE,(bal)=>{
									setXHubbleBalance(bal)
								})	
							})
						}
						)
				} 
			}
			)
}
	
}
const earlyExit = () => {
	if (Number(unlockRef.current.value) == 0) {
		alert("Enter a nonzero value")
	}
	else {
		let amt = web3.utils.toWei(unlockRef.current.value,"ether")
		let data = xHUBBLE.methods.crash(amt).encodeABI()
		setPendingText("Crashing out your $xHUBBLE for $HUBBLE!?!!")
		sendRequest(
			xHUBBLE.options.address,
			data,
			()=>{
				getBal(HUBBLE,(bal)=>{
					setHubbleBalance(bal)
				})
				getBal(xHUBBLE,(bal)=>{
					setXHubbleBalance(bal)
				})
			})
	}
	
}
const getVestCount = () => {
	xHUBBLE.methods.usersTotalVests(address)
		.call({from: address})
		.then((count)=>{
			setVestCount(count)
		})
}
const getVestInfo = (index) => {
	xHUBBLE.methods.vestInfo(address,index)
		.call({from: address})
		.then((output)=>{
			setVestInfo({
				amt: Number(output.amount),
				start: Number(output.start),
				end: Number(output.maxEnd),
				id: Number(output.vestID)
			})
			console.log(output)
		})
}
const vest = () => {
	if (Number(vestRef.current.value) == 0) {
		alert("Enter a nonzero value")
	}
	else {
		let amt = web3.utils.toWei(vestRef.current.value,"ether")
		let data = xHUBBLE.methods.createVest(amt).encodeABI()
		setPendingText("Vesting your $xHUBBLE for $HUBBLE... see you in 180 days!")
		sendRequest(
			xHUBBLE.options.address,
			data,
			()=>{
				getBal(HUBBLE,(bal)=>{
					setHubbleBalance(bal)
				})
				getBal(xHUBBLE,(bal)=>{
					setXHubbleBalance(bal)
					getVestCount()
				})
			})
	}
}

const HubbleIcon = ()=>(<div className="icon icon--hubble"><img src={dd}/></div>)
const XhubbleIcon = ()=>(<div className="icon icon--xhubble"><img src={xi}/></div>)
const McIcon = ()=>(<div className="icon icon--mc"><img src={mc}/></div>)
const prevVest = () => {
	if (activeVest > 0) {
		setActiveVest(activeVest - 1)
	}
	
}

const nextVest = () => {
	if (activeVest < Number(vestCount) -  1) {
		setActiveVest(activeVest + 1)
	}
	
}

const getTotalSubmissions = (callback=()=>{}) => {
	wl.methods.totalSubmissions()
		.call({from: address})
		.then((count)=>{
			setTotalSubmissions(count)
			callback()
		})
}

const getUserSubmissionCount = (callback=()=>{})=>{
	wl.methods.submissionCountByUser(address)
		.call({from: address})
		.then((count)=>{
			setWlCount(count)
			callback()
		})
}

const submitForWhitelist = () => {
	
	
	if (!web3.utils.isAddress(wlRef.current.value)) {
		alert("ERROR: please submit a valid address")
	} 
	else {
		alert("You will be required to keep 42 xHUBBLE throughout genesis or this pool's emissions will turn off.")
		let addy = wlRef.current.value
	let token = new web3.eth.Contract(
		networkConfig["hubble"]["abi"], 
		addy)
	let data = wl.methods.submit(addy).encodeABI()
		checkAllowance(
		token,
		wl.options.address,
		1,
		(allowance) => {
			
			if (allowance >= 1) {
				setPendingText("Submitting your token")
				sendRequest(
					wl.options.address,
					data,
					()=>{
						getTotalSubmissions(getUserSubmissionCount(getTheList))
						
					})
			} 
			else {
				setPendingText("Approving a small amount of your token to send to the whitelist contract");
				approve(
					token,
					wl.options.address,
					1,
					()=>{
						setPendingText("Submitting your token")
						sendRequest(
						wl.options.address,
						data,
						()=>{
							getTotalSubmissions(getUserSubmissionCount(getTheList))
						})
					}
					)
			} 
		}
		)
	} 
	
}

const getTheList = (callback = ()=>{}) => {
	wl.methods.fetchSubmissions()
		.call({from: address})
		.then((wls)=>{
			setTheList(wls)
			callback()
		})
}

const getTheNames = (callback = ()=>{}) => {
	wl.methods.fetchNames()
		.call({from: address})
		.then((wls)=>{
			setTheNames(wls)
			callback()
		})
}

const getTheSymbols = (callback = ()=>{}) => {
	wl.methods.fetchSymbols()
		.call({from: address})
		.then((wls)=>{
			setTheSymbols(wls)
			callback()
		})
}

const exitVest = (callback = ()=>{}) =>{
	console.log(vestInfo)
	let data = xHUBBLE.methods.exitVest(Number(vestInfo.id)).encodeABI()
	setPendingText("Exiting your Vest. Please be sure you understand what this means!")
	sendRequest(
		xHUBBLE.options.address,
		data,
		()=>{
			callback()
			getVestCount()
			getVestInfo()
			getBal(HUBBLE,(bal)=>{
				setHubbleBalance(bal)
			})
			getBal(xHUBBLE,(bal)=>{
				setXHubbleBalance(bal)
			})
		}
		)
}

// -------------------------------------
// Mission Control

const getMcBalance = () => {
	MC.methods.balanceOf(address)
		.call({from: address})
		.then((bal)=>{
			setMcBalance(bal)
		})
}

const stakeMC = (amt,callback = ()=>{}) => {
	let data = MC.methods.stake(amt).encodeABI()
	setPendingText("Staking your xHUBBLE")
	
	sendRequest(
		MC.options.address,
		data,
		()=>{
			getBal(xHUBBLE,
				(bal)=>{
					setXHubbleBalance(bal)
					getMcBalance()
					callback()
				})
			
		}
		)
}

const unstakeMC = (callback = ()=>{}) => {
	let data = MC.methods.withdraw(web3.utils.toWei(unstakeRef.current.value,"ether")).encodeABI()
	setPendingText("Unstaking your xHUBBLE")
	
	sendRequest(
		MC.options.address,
		data,
		()=>{
			getBal(xHUBBLE,
				(bal)=>{
					setXHubbleBalance(bal)
					getMcBalance()
					callback()
				})
			
		}
		)
}


const stake = () => {
	// check allowance of MC to spend xHUBBLE
	// approve if necessary
	// stake
	let amt = web3.utils.toWei(stakeRef.current.value,"ether")

	checkAllowance(
		xHUBBLE,
		MC.options.address,
		amt,
		(allowance)=>{
			if (web3.utils.fromWei(allowance,"ether") < Number(stakeRef.current.value)) {
				// approve 
				setPendingText("Approving Mission Control as a spender of your xHUBBLE")
				approve(
					xHUBBLE,
					MC.options.address,
					amt,
					() => {
						stakeMC(amt)
					}

					
					
					)
			}
			else {
				stakeMC(amt)
			}
		}
		)
}
const unstake = () => {

	unstakeMC()
}
// ------------------------------------------------------------------------------------------------------


const toggleMobileNav = () => {
	if(navMobileToggle) {
		setNavMobileToggle(false)
	}
	else {
		setNavMobileToggle(true)
	}
}



const [totalStaked, setTotalStaked] = React.useState(1)
const getTotalStaked = () => {
	MC.methods.totalSupply()
		.call({from: address})
		.then((supply)=>{
			setTotalStaked(supply)
		})
}

const fetchPrice = (tokenAddress, callback = ()=>{}) => {
	const baseUrl = "https://www.hubble-server.xyz:1443/price";
  	const url = `${baseUrl}?token=${tokenAddress}`;
  	fetch(url)
  		.then((response)=>{
			//console.log(response)
			response.json()
				.then((json) =>{
					//console.log(json)
					callback(json)
				})
			})
}

// apr = annual emissions / tvl
// tvl = price of token * balance of token

const getMC2Info = (callback = () =>{}) => {
	MC2.methods.poolInfo(0)
		.call({from: address})
		.then((poolInfo)=>{
			console.log("getting pool info", poolInfo)
			callback(poolInfo)
		})
}
const getDEMInfo = (callback = () =>{}) => {
	MC2.methods.poolInfo(1)
		.call({from: address})
		.then((poolInfo)=>{
			console.log("getting pool info", poolInfo)
			callback(poolInfo)
		})
}


const getUserInfo = (callback = ()=>{}) => {
		MC2.methods.userInfo(0,address)
		.call({from:address})
		.then((userInfo)=>{
			console.log("getting user info", userInfo)

			setMc2bal(userInfo)
			callback(userInfo)
			
		})
}

const getDemUserInfo = (callback = ()=>{}) => {
	MC2.methods.userInfo(1,address)
			.call({from:address})
			.then((userInfo1)=>{
				console.log("getting user info", userInfo1)

			
				setDembal(userInfo1)
				callback(userInfo1)
			})
}

const setRefToThis = (setToThis,theRef) => {
	return () => {
		console.log(setToThis)
		theRef.current.value = setToThis
	}
}

const deposit = (amt,pid=0,callback=()=>{}) => {
	console.log(amt)
	let data = MC2.methods.deposit(pid,amt).encodeABI()
	if (pid == 0) {
		setPendingText(`Depositing your xHUBBLE to Mission Control`)
	}
	else {
		setPendingText(`Depositing your xEX to the Dark Energy Module`)
	}
	
	sendRequest(
		MC2.options.address,
		data,
		() => {
			callback()
			if (pid == 0) getMC2Info(getUserInfo(getPendingRewards()))
			if (pid == 1) getDEMInfo(getDemUserInfo(getPendingRewardsDEM()))
			getBal(XEX,(b)=>{
	  					setXexBalance(b)
	  				
	  				})
		}
		)
}


const stakeMc2 = () => {
return ()=>{

		let amt = web3.utils.toWei(mc2StakeRef.current.value,"ether")
		console.log(amt)
		checkAllowance(
			xHUBBLE,
			MC2.options.address,
			amt,
			(allowance)=>{
				if (web3.utils.fromWei(allowance,"ether") >= mc2StakeRef.current.value) {
					deposit(amt)
				}
				else {
					setPendingText(`Approving MC2 Contract to spend your xHUBBLE`)
					approve(
						xHUBBLE,
						MC2.options.address,
						amt,
						() => {
							deposit(amt)
						})
				}
			})
	}
}

const unstakeMc2 = () => {
	return () => {
	let amt = web3.utils.toWei(mc2UnstakeRef.current.value,"ether")
	let data = MC2.methods.withdraw(0,amt).encodeABI()
	setPendingText(`Withdrawing your xHUBBLE`)
	sendRequest(
		MC2.options.address,
		data,
		()=>{
			getMC2Info(getUserInfo(getPendingRewards()))
			getBal(xHUBBLE,(b)=>{
	  					setXHubbleBalance(b)
	  					
	  				})
		}
		)
	}
}

const claimRewardsMc2 = (callback=()=>{}) => {
	return ()=>{
		let data = MC2.methods.deposit(0,0).encodeABI()
		setPendingText(`Claiming your Mission Control v2 Rewards`)
		sendRequest(
			MC2.options.address,
			data,
			() => {
				getMC2Info(getUserInfo(getPendingRewards()))
				callback()
			}
			)
	}
}

const [pr,setPr] =React.useState(["0","0","0","0","0"])
const getPendingRewards = () => {
	MC2.methods.pendingRewards(0,address)
		.call({from: address})
		.then((prs)=>{
			setPr(prs)
		})
}





const gexData = () => {
	EX121.methods.remainingMints(address)
		.call({from: address})
		.then((rm)=>{
			setRemainingMints(rm)
			EX121.methods.mints(address)
				.call({from: address})
				.then((rex)=>{
					setExMints(rex)
				})
		})

}


const _mint = (amt)=>{
	let ma = web3.utils.fromWei(amt,"ether")

	let data = EX121.methods.mint(amt).encodeABI()
	setPendingText(`Minting ${ma} EX for ${ma} stS`)
	sendRequest(
		EX121.options.address,
		data,
		() => {

			gexData()
		}
		)
}
const mint121 = () => {

	setIsMinting(false)
	let amt = web3.utils.toWei(exMintRef.current.value,"ether")
	let numamt = Number(exMintRef.current.value)
	let stsBal = Number(web3.utils.fromWei(stsBalance,"ether"))
	let remaining = Number(web3.utils.fromWei(remainingMints,"ether"))

		if (numamt >= 1) {
	if (numamt <= stsBal) {
		if (numamt <= remaining) {	
			checkAllowance(
				STS,
				EX121.options.address,
				amt,
				(allowance)=>{
					let alw = Number(web3.utils.fromWei(allowance,"ether"))
				 	if (alw >= numamt)  {
				 		alert(`Minting ${numamt} while allowance is ${alw}`)
						_mint(amt)
					}
					else {
						setPendingText(`Approving Minting Contract to spend your stS`)
						approve(
							STS,
							EX121.options.address,
							amt,
							() => {
								_mint(amt)
							})
					}
				})
		} else {
			alert("You do not have enough xHUBBLE. Each xHUBBLE affords a user 10000 mints.")
		}
	}
	else {
		alert("You do not have enough stS")
	}} else {
		alert("You must mint at least 1 $EX")
	}
	 
}

const ogMintPopup = ()=>{
	setIsMintingOG(true)
}
const hubblerMintPopup = ()=>{
	setIsMintingHubbler(true)
}

const mintPopup = ()=>{
	setIsMinting(true)
}
const closeMintOG = () =>{
	setIsMintingOG(false)
}
const closeMintHubbler = () => {
	setIsMintingHubbler(false)
}

const closeMint = () =>{
	setIsMinting(true)
}

const [mintingAmount, setMintingAmount] = React.useState(0)
React.useEffect(()=>{
	if (isMinting) {
		setMintingAmount(Number(exMintRef.current.value))
	}

},[isMinting])

const [ogMintingAmount, setOGMintingAmount] = React.useState(0)
React.useEffect(()=>{
	if (isMintingOG) {
		setOGMintingAmount(Number(ogMintRef.current.value))
	}

},[isMintingOG])


const [hubblerMintingAmount, setHubblerMintingAmount] = React.useState(0)
React.useEffect(()=>{
	if (isMintingHubbler) {
		setHubblerMintingAmount(Number(hubblerMintRef.current.value))
	}

},[isMintingHubbler])

const lockEx = () => {
	if (Number(exRef.current.value) == 0) {
		alert("Enter a nonzero value")
	}
	else {
		let amt = web3.utils.toWei(exRef.current.value,"ether")
		let data = XEX.methods.lock(amt).encodeABI()

		checkAllowance(
			EX,
			XEX.options.address,
			amt,
			(allowance) => {
				let alw = web3.utils.fromWei(allowance,"ether")
				if (alw >= Number(exRef.current.value)) {
					setPendingText("Locking $EX")
					sendRequest(
						XEX.options.address,
						data,
						()=>{
							getBal(EX,(bal)=>{
								setExBalance(bal)
							})
							getBal(XEX,(bal)=>{
								setXexBalance(bal)
						
							})
						})
				} 
				else {
					setPendingText("Approving your $EX for use by the $xEX contract.")
					approve(
						EX,
						XEX.options.address,
						amt,
						()=>{
							setPendingText("Locking $EX")
							sendRequest(
							XEX.options.address,
							data,
							()=>{
								getBal(EX,(bal)=>{
									setExBalance(bal)
								})
								getBal(XEX,(bal)=>{
									setXexBalance(bal)
							
								})
							})
						}
						)
				} 
			}
			)
}
	
}
const earlyExitXEX = () => {
	if (Number(xexRef.current.value) == 0) {
		alert("Enter a nonzero value")
	}
	else {
		let amt = web3.utils.toWei(xexRef.current.value,"ether")
		let data = XEX.methods.crash(amt).encodeABI()
		setPendingText("Crashing out your $xEX for $EX!?!!")
		sendRequest(
			XEX.options.address,
			data,
			()=>{
				getBal(EX,(bal)=>{
									setExBalance(bal)
								})
								getBal(XEX,(bal)=>{
									setXexBalance(bal)
							
								})
			})
	}
	
}
const vestXEX = () => {
	if (Number(vestXEXRef.current.value) == 0) {
		alert("Enter a nonzero value")
	}
	else {
		let amt = web3.utils.toWei(vestXEXRef.current.value,"ether")
		let data = XEX.methods.createVest(amt).encodeABI()
		setPendingText("Vesting your $xEX for $EX... see you in 14 days!")
		sendRequest(
			XEX.options.address,
			data,
			()=>{
				getBal(EX,(bal)=>{
					setExBalance(bal)

				})
				getBal(XEX,(bal)=>{
					setXexBalance(bal)
			
				})
			})
	}
}
const exitVestXEX = (callback = ()=>{}) =>{
	console.log(vestXEXInfo)
	let data = XEX.methods.exitVest(Number(vestXEXInfo.id)).encodeABI()
	setPendingText("Exiting your Vest. Please be sure you understand what this means!")
	sendRequest(
		XEX.options.address,
		data,
		()=>{
			callback()
			getVestXEXCount()

			getBal(EX,(bal)=>{
					setExBalance(bal)

				})
				getBal(XEX,(bal)=>{
					setXexBalance(bal)
			
				})
		}
		)
}

const prevVestXEX = () => {
	if (activeXEXVest > 0) {
		setActiveVest(activeXEXVest - 1)
	}
	
}

const nextVestXEX = () => {
	if (activeXEXVest < Number(vestXEXCount) -  1) {
		setActiveVest(activeXEXVest + 1)
	}
	
}
const getVestXEXCount = () => {
	console.log("getting ex vests")
	XEX.methods.usersTotalVests(address)
		.call({from: address})
		.then((count)=>{
			setVestXEXCount(count)
		})
}
const getVestXEXInfo = (index) => {
	XEX.methods.vestInfo(address,index)
		.call({from: address})
		.then((output)=>{
			setVestXEXInfo({
				amt: Number(output.amount),
				start: Number(output.start),
				end: Number(output.maxEnd),
				id: Number(output.vestID)
			})
			console.log(output)
		})
}

// ---------------------------------------------------------------------------------

const stakeDEM = () => {
return ()=>{

		let amt = web3.utils.toWei(demStakeRef.current.value,"ether")
		console.log(amt)
		checkAllowance(
			XEX,
			MC2.options.address,
			amt,
			(allowance)=>{
				if (web3.utils.fromWei(allowance,"ether") >= demStakeRef.current.value) {
					deposit(amt,1)
				}
				else {
					setPendingText(`Approving MC2 Contract to spend your xEX`)
					approve(
						XEX,
						MC2.options.address,
						amt,
						() => {
							deposit(amt,1)
						})
				}
			})
	}
}

const unstakeDEM = () => {
	return () => {
	let amt = web3.utils.toWei(demUnstakeRef.current.value,"ether")
	let data = MC2.methods.withdraw(1,amt).encodeABI()
	setPendingText(`Withdrawing your xEX`)
	sendRequest(
		MC2.options.address,
		data,
		()=>{
			getDEMInfo(getDemUserInfo(getPendingRewardsDEM()))
			getBal(XEX,(b)=>{
	  					setXexBalance(b)
	  					
	  				})
		}
		)
	}
}

const claimRewardsDEM = (callback=()=>{}) => {
	return ()=>{
		let data = MC2.methods.deposit(1,0).encodeABI()
		setPendingText(`Claiming your Dark Energy Module Rewards`)
		sendRequest(
			MC2.options.address,
			data,
			() => {
				getDEMInfo(getDemUserInfo(getPendingRewardsDEM()))
				callback()
			}
			)
	}
}

const [prdem,setPrDem] =React.useState(["0","0","0","0","0"])
const getPendingRewardsDEM = () => {
	MC2.methods.pendingRewards(1,address)
		.call({from: address})
		.then((prs)=>{
			setPrDem(prs)
		})
}


  return (
  	<div className={"App App--" + isConnected + " App-chain--" + chainId}>
  		<div className="the-back" style={{backgroundImage: `url(${bg})`}}></div>
  		<div className="the-back cover"></div>
	  	<div className="bg" >
	  		<div className="inner">
	  			<div className="inner-inner">
		  			
		  			
		  			<div className={"step step-1 step--"+activeStep}>
		  				<div className="step-title"><img src={dd}/><span>HUBBLE Testnet</span></div>
		  				<p>Test 1-to-1 EX Minting at the Galactic Exchange</p>
		  				
		  			</div>
		  			<div className={"step step-2 step--"+activeStep}>

		  				<div className="step-title"><img src={xi}/><span>Galactic Bank: HUBBLE Desk</span></div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Convert HUBBLE to xHUBBLE</h2>
		  						<p>Convert HUBBLE to xHUBBLE at any time. The process is instant, and the ratio is 1:1.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={dd} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Convert</div>
		  								<div className="large">HUBBLE</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={hubbleRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(hubbleBalance,"ether"),
								  									hubbleRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(hubbleBalance,"ether")}</span>
		  						</div>
		  						<button onClick={lock}>Lock</button>
		  					</div>
		  				</div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Vested Exit</h2>
		  						<p>Redeem xHUBBLE over a vesting period. Choose a minimum vest of 15 days (1:0.5 ratio) to maximum vest of 6 months (1:1 ratio). You can cancel the vest in the first 14 days.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xi} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Vest</div>
		  								<div className="large">xHUBBLE</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={vestRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(xhubbleBalance,"ether"),
								  									vestRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(xhubbleBalance,"ether")}</span>
		  						</div>
		  						<button onClick={vest}>Vest</button>
		  					</div>
		  				</div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Instant Exit</h2>
		  						<p>Instantly exit to HUBBLE, incurring a 50% penalty. This process cannot be reverted, all forfeited HUBBLE is streamed back to stakers.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xi} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Exit</div>
		  								<div className="large">xHUBBLE</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={unlockRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(xhubbleBalance,"ether"),
								  									unlockRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(xhubbleBalance,"ether")}</span>
		  						</div>
		  						<button onClick={earlyExit}>Exit</button>
		  					</div>
		  				</div>
		  				<div>
		  				<p>You have {vestCount} vests.</p>
				  			<div className="vest">
				  			 <p>Vest {activeVest}</p> 
				  			 <p>{web3.utils.fromWei(vestInfo.amt,"ether")} <HubbleIcon/></p>
				  			 <p>Vesting for {Math.round((vestInfo.end - Date.now()/1000)/(60 * 60 * 24))} Days</p>
				  			</div>
				  			<p><button onClick={exitVest}>Exit Vest</button></p>
				  			<p><button onClick={prevVest}>Previous Vest</button><button onClick={nextVest}>Next Vest</button></p>
			  			</div>
			  			<div className="step-title"><img src={xi}/><span>Galactic Bank: EX Desk</span></div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Convert EX to xEX</h2>
		  						<p>Convert EX to xEX at any time. The process is instant, and the ratio is 1:1.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={ex} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Convert</div>
		  								<div className="large">EX</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={exRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(exBalance,"ether"),
								  									exRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(exBalance,"ether")}</span>
		  						</div>
		  						<button onClick={lockEx}>Lock</button>
		  					</div>
		  				</div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Vested Exit</h2>
		  						<p>Redeem xEX over a vesting period. Choose a minimum vest of 8 days (1:0.5 ratio) to maximum vest of 14 days (1:1 ratio). You can cancel the vest in the first 7 days.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xex} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Vest</div>
		  								<div className="large">xEX</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={vestXEXRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(xexBalance,"ether"),
								  									vestXEXRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(xexBalance,"ether")}</span>
		  						</div>
		  						<button onClick={vestXEX}>Vest</button>
		  					</div>
		  				</div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Instant Exit</h2>
		  						<p>Instantly exit to EX, incurring a 50% penalty. This process cannot be reverted, all forfeited EX is streamed back to stakers.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xex} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Exit</div>
		  								<div className="large">xEX</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={xexRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(xexBalance,"ether"),
								  									xexRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(xexBalance,"ether")}</span>
		  						</div>
		  						<button onClick={earlyExitXEX}>Exit</button>
		  					</div>
		  				</div>
		  				<div>
		  					<p>You have {vestXEXCount} vests.</p>
				  			<div className="vest">
				  			 <p>Vest {activeXEXVest}</p> 
				  			 <p>{web3.utils.fromWei(vestXEXInfo.amt,"ether")} <div className="icon icon--ex"><img src={ex}/></div></p>
				  			 <p>Vesting for {Math.round((vestXEXInfo.end - Date.now()/1000)/(60 * 60 * 24))} Days</p>
				  			</div>
				  			<p><button onClick={exitVestXEX}>Exit Vest</button></p>
				  			<p><button onClick={prevVestXEX}>Previous Vest</button><button onClick={nextVestXEX}>Next Vest</button></p>
			  			</div>
		  			</div>

		  			<div className={"step step-3 step--"+activeStep}>
		  				<div className="step-title"><img src={mc}/><span>Mission Control v2</span></div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Claim your Rewards</h2>
		  						<p>Claim your Rewards</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xi} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Claim</div>
		  								<div className="large">Rewards</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<div>{web3.utils.fromWei(pr[0],"ether")} HUBBLE + {web3.utils.fromWei(pr[1],"ether")} xHUBBLE</div>
		  
		  							<div>{web3.utils.fromWei(pr[2],"ether")} EX + {web3.utils.fromWei(pr[3],"ether")} xEX</div>
		  							<div>{Number(pr[4])/1e6} USDC</div>
		  						</div>
		  						<button onClick={claimRewardsMc2()}>Claim</button>
		  					</div>
		  				</div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Stake your $xHUBBLE</h2>
		  						<p>Stake your $xHUBBLE in Mission Control v2 to earn rewards and participate in governance.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xi} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Stake</div>
		  								<div className="large">xHUBBLE</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={mc2StakeRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(xhubbleBalance,"ether"),
								  									mc2StakeRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(xhubbleBalance,"ether")}</span>
		  						</div>
		  						<button onClick={stakeMc2()}>Stake</button>
		  					</div>
		  				</div>
		  			
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Unstake your $xHUBBLE</h2>
		  						<p>Unstake your $xHUBBLE from Mission Control v2 to stop earning rewards and reset your votes.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xi} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Unstake</div>
		  								<div className="large">xHUBBLE</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={mc2UnstakeRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(mc2Bal,"ether"),
								  									mc2UnstakeRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(mc2Bal,"ether")}</span>
		  						</div>
		  						<button onClick={unstakeMc2()}>Unstake</button>
		  					</div>
		  				</div>
		  		
		  				<div className="step-title"><img src={mc}/><span>Mission Control v1</span></div>
		  				
		  				
		  			
		  				
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Unstake your $xHUBBLE</h2>
		  						<p>Unstake your $xHUBBLE from Mission Control to stop earning rewards and reset your votes.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xi} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Unstake</div>
		  								<div className="large">xHUBBLE</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={unstakeRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(mcBalance,"ether"),
								  									unstakeRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(mcBalance,"ether")}</span>
		  						</div>
		  						<button onClick={unstake}>Unstake</button>
		  					</div>
		  				</div>
		  

		  			</div>
		  	
		  		
		  			<div className={"step step-4 step--"+activeStep}>
		  				<div className="step-title"><img src={mc}/><span>Galactic Exchange: Special Market</span></div>
		  				<div className="data-tile">
		  					<h3>Mints</h3>
		  					<p className="data-focus">{Math.round(100*web3.utils.fromWei(exMints,"ether"))/100} $EX</p>
		  					<p className="data-item">/{EX_LIMIT} $EX</p>
		  				</div>
		  			
		  				<div className="data-tile">
		  					<h3>Your Remaining Mints</h3>
		  					<p className="data-focus">{Math.round(100*web3.utils.fromWei(remainingMints,"ether")/100)} $EX</p>
		  					
		  				</div>
		  			
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Mint $EX 1-to-1</h2>
		  						<p>Mint 1 liquid $EX for 1 $stS. Users can mint 10,000 $EX for each $xHUBBLE they hold.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={ex} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Mint</div>
		  								<div className="large">EX</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={exMintRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(stsBalance,"ether"),
								  									exMintRef)}>MAX</button>
		  			
		  						</div>
		  						<button onClick={mintPopup}>Mint</button>
		  					</div>
		  				</div>

		  			</div>
		  			<div className={"step step-5 step--"+activeStep}>
		  				<div className="step-title"><img src={xex}/><span>Dark Energy Module</span></div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Claim your Rewards</h2>
		  						<p>Claim your Rewards</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xi} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Claim</div>
		  								<div className="large">Rewards</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<div>{web3.utils.fromWei(prdem[0],"ether")} HUBBLE + {web3.utils.fromWei(prdem[1],"ether")} xHUBBLE</div>
		  							<div>{web3.utils.fromWei(prdem[2],"ether")} EX + {web3.utils.fromWei(prdem[3],"ether")} xEX</div>
		  							<div>{Number(prdem[4])/1e6} USDC</div>
		  						</div>
		  						<button onClick={claimRewardsDEM()}>Claim</button>
		  					</div>
		  				</div>
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Stake your $xEX</h2>
		  						<p>Stake your $xEX in the Dark Energy Module to earn rewards.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xex} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Stake</div>
		  								<div className="large">xEX</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={demStakeRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(xexBalance,"ether"),
								  									demStakeRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(xexBalance,"ether")}</span>
		  						</div>
		  						<button onClick={stakeDEM()}>Stake</button>
		  					</div>
		  				</div>
		  			
		  				<div className="locker">
		  					<div className="locker-text">
		  						<h2>Unstake your $xEX</h2>
		  						<p>Unstake your $xEX from the Dark Energy Module to stop earning rewards.</p>
		  					</div>
		  					<div className="locker-locker">
		  						<div className="locker-icon">
		  							<div className="hubble-icon">
		  								<img src={xex} />
		  							</div>
		  							<div className="icon-text">
		  								<div className="small">Unstake</div>
		  								<div className="large">xEX</div>
		  							</div>
		  						</div>
		  						<div className="locker-input">
		  							<input ref={demUnstakeRef} placeholder="0"/>
		  							<button className="max-button" onClick={
								  								setRefToThis(
								  									web3.utils.fromWei(demBal,"ether"),
								  									demUnstakeRef)}>MAX</button>
		  							<span>Balance: {web3.utils.fromWei(demBal,"ether")}</span>
		  						</div>
		  						<button onClick={unstakeDEM()}>Unstake</button>
		  					</div>
		  				</div>
		  		
		  				
		  

		  			</div>
		  		</div>
	       	</div>

	       	<div onClick={toggleMobileNav} className={"nav nav--"+navMobileToggle}>
	       	
	       
				
	       		
	       	
	       		
	       		<div className="link" onClick={()=>{
	       			setActiveStep(2)
	       		}}>Galactic Bank</div>
	       		<div className="link" onClick={()=>{
	       			setActiveStep(4)
	       		}}>Galactic Exchange</div>
	       		<div className="link" onClick={()=>{
	       			setActiveStep(3)
	       		}}>Mission Control</div>
	       		
	       		<div className="link" onClick={()=>{
	       			setActiveStep(5)
	       		}}>Dark Energy Module</div>
	
	       		
	      
	       	</div>
	       	<div className="wallet">
		  				<HubbleIcon /> <span title="hubble">{Math.round(web3.utils.fromWei(hubbleBalance,"ether")*1000)/1000}</span> 
		  				<span className="divider"> // </span> 
		  				<XhubbleIcon /> <span title="xhubble">{Math.round(web3.utils.fromWei(xhubbleBalance,"ether")*1000)/1000}</span>
		  				<span className="divider"> // </span> 
		  				<McIcon /> <span title="staked xhubble">{Math.round(web3.utils.fromWei(mc2Bal,"ether")*1000)/1000}</span>
		  			</div>
		  			<div className="wallet wallet--2">
		  				<div className="icon icon--sts"><img src={sts}/></div><span title="sts">{Math.round(web3.utils.fromWei(stsBalance,"ether")*1000)/1000}</span> 
		  				<span className="divider"> // </span> 
		  				<div className="icon icon--ex"><img src={ex}/></div><span title="sts">{Math.round(web3.utils.fromWei(exBalance,"ether")*1000)/1000}</span> 
		  				<span className="divider"> // </span> 
		  				<div className="icon icon--xex"><img src={xex}/></div><span title="sts">{Math.round(web3.utils.fromWei(xexBalance,"ether")*1000)/1000}</span> 
		  			</div>


	        <div className="dd"><img src={dd} /></div>	  		
	        <div className="connect-button">
	  			<div className="inliner"><ConnectButton /></div>
	  		</div>
	  		<div className={"pending pending--" + isMinting}>
	  			<p className="pending-title">Minting $EX</p>
	  			<p className="pending-text">You will mint {mintingAmount} $xEX for {mintingAmount} $stS.</p>
	  			<button onClick={mint121}>MINT</button>
	  			<button onClick={closeMint}>BACK</button>

	  		</div>
	  		
	        <div className={"pending pending--" + pending}>
	  			<p className="pending-title">Transaction Pending</p>
	  			<p className="pending-text">{pendingText}</p>
	  			<div className="pending-animation">
	  				<div className="animation"><img src={pend}/></div>
	  			</div>
	  		</div>
      	</div>
  	</div>
  	)
};